import React, { useEffect, useRef } from 'react'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
  container: {
    left: 90,
    width: 580,
    height: '100%',
    top: 0,
    position: 'absolute',
    transition: 'transform .5s',
    backgroundColor: theme.mode.backgroundColor.medium,
    boxShadow: '0 3px 15px 0 rgba(0, 0, 0, 0.16)',
    overflow: 'hidden',
  },
  open: {
    transform: 'translateX(0px)',
    zIndex: 100,
  },
  closed: {
    transform: 'translateX(-100%)',
  },
  [theme.devices.mobile]: {
    container: ({ isTopPanelVisible }) => ({
      backgroundColor: theme.mode.backgroundColor.medium,
      top: isTopPanelVisible ? 75 : 50,
      left: 0,
      height: '100vh',
      width: '100%',
      flexDirection: 'column',
    }),
    open: {
      transform: 'translateY(0px)',
      zIndex: 100,
    },
    closed: {
      zIndex: -100,
      transform: 'translateY(-100%)',
    },
  },
}))

const MenuOverlay = ({ children, open = false, closeMenuOverlay, isTopPanelVisible }) => {
  const classes = useStyles({ open, isTopPanelVisible })
  const ref = useRef()

  useEffect(() => {
    if (!open) return

    document.addEventListener('mousedown', event => {
      if (!ref || !ref.current || ref.current.parentNode.contains(event.target)) return

      closeMenuOverlay()
    })
  }, [open])

  return (
    <div
      ref={ref}
      className={clsx(classes.container, open ? classes.open : classes.closed)}
    >{children}</div>
  )
}

export default MenuOverlay
